import React from "react";
import PropTypes from "prop-types";
import GlobalBanner from "asos-contentweb-global-banners";

class WithTargetedContent extends React.Component {
  constructor() {
    super();
    this.state = {
      contentRequested: false
    };
  }

  componentDidMount() {
    this.manageRequest();
  }

  componentDidUpdate() {
    this.manageRequest();
  }

  manageRequest() {
    if (this.props.identityHasResponded && !this.state.contentRequested) {
      const parameters = this.getParameters({ ...this.props });
      const context = this.getContext({ ...this.props });

      this.props.requestTargetedContent(parameters, context);
      this.setState({ contentRequested: true });
    }
  }

  getParameters(props) {
    const viewscope = this.getViewScope();
    const params = {
      country: props.country,
      store: props.store,
      lang: props.lang,
      keystoredataversion: props.keystoredataversion,
      ...(viewscope !== "default" && { viewscope: viewscope })
    };

    return params;
  }

  getContext(props) {
    return {
      premier: props.premier ? "T" : "F",
      customerStatus:
        props.isRecognised || props.isLoggedIn ? "known" : "unknown"
    };
  }

  getViewScope() {
    return window.asos.webContext.getWebContext().floor;
  }

  render() {
    const emptyReturnValue =
      this.props.contentTargetingStatus === "SUCCESS" && !this.props.content;

    if (this.props.contentTargetingStatus === "ERROR" || emptyReturnValue) {
      return null;
    }

    return (
      <GlobalBanner
        content={this.props.content}
        status={this.props.contentTargetingStatus}
      />
    );
  }
}

WithTargetedContent.defaultProps = {
  isRecognised: false
};

WithTargetedContent.propTypes = {
  content: PropTypes.object,
  requestTargetedContent: PropTypes.func.isRequired,
  identityHasResponded: PropTypes.bool.isRequired,
  contentTargetingStatus: PropTypes.string.isRequired
};

export default WithTargetedContent;
